<script>
import SicantikStatistik from '@/components/dashboard/sicantik/Statistik.vue'
import SicantikPerBulan from '@/components/dashboard/sicantik/PerBulan.vue'
import SicantikJenisIzin from '@/components/dashboard/sicantik/JenisIzin.vue'

export default {
   components: {
      SicantikStatistik,
      SicantikPerBulan,
      SicantikJenisIzin,
   },
}
</script>

<template>
   <div>
      <SicantikStatistik />
      <SicantikPerBulan />
      <SicantikJenisIzin />
   </div>
</template>

<style scoped></style>
